import * as _ from 'lodash-es'
import { useContext } from 'react'
import { Box } from '@chakra-ui/react'
import { useAction } from "../useAction.js"
import { PtInput, Ptext } from '../../../componentsF/Chakra3F/ChakraF.jsx'
import { useLocalStorage } from "../../../componentsF/localStorageF/LocalStorWrapF.tsx"
import { RoundedButton } from '../GameCompsF.jsx'
import { GameContext } from '../GameContextF.jsx'


const usePlayerAlias = () => useLocalStorage('playerAlias', '')

const allowedChars = 'abcdefghijklmnopqrstuvwxyz0123456789'

export const SetPlayerNameComp = () => {

  const [playerAlias, setPlayerAlias] = usePlayerAlias()

  const {doAction: doAction, loading} = useAction({playerAction: 'setPlayerAlias', playerAlias})
  const doJoinGame = () => {
    if (playerAlias == '') return
    doAction?.()
  }

  const onKeyDown = (evt) => {
    if (evt.key == 'Enter') {
      doJoinGame()
      return
    }
  }

  const onChange = (evt) => {
    const value = evt.target.value.toLowerCase()
    const filteredValue = _.filter(value, char => {
      return _.includes(allowedChars, char)
    }).join('')
    
    setPlayerAlias(filteredValue)
  }

  return <>
    <Box {...{fontSize: '6xl', my: 5}}>
      <Ptext>Enter Username:</Ptext>
      <PtInput {...{
        'data-testid': 'alias-input',
        'data-bwignore': 'true', 'data-lpignore': 'true', 'data-1p-ignore': '',
        type: 'text',
        autoComplete: 'off', autoCorrect: 'off', spellCheck: 'false', autoCapitalize: 'off',
        pattern: `[${allowedChars}]+`,
        maxLength: 16, onKeyDown, style: {textTransform: 'lowercase'}, fontSize: '4xl', padding: 2, height: 20, textAlign: 'center', onChange,
        value: playerAlias,
      }} />
    </Box>
    <RoundedButton {...{'data-testid': 'join-button', onClick: doJoinGame, isLoading: loading}}>
      Join Game
    </RoundedButton>
  </>
}